var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchSm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "search-sm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Solid",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 2.09082C6.24871 2.09082 2.66699 5.67254 2.66699 10.0908C2.66699 14.5091 6.24871 18.0908 10.667 18.0908C12.5157 18.0908 14.218 17.4637 15.5726 16.4107L20.9599 21.7979C21.3504 22.1885 21.9836 22.1885 22.3741 21.7979C22.7646 21.4074 22.7646 20.7742 22.3741 20.3837L16.9868 14.9965C18.0399 13.6418 18.667 11.9395 18.667 10.0908C18.667 5.67254 15.0853 2.09082 10.667 2.09082ZM4.66699 10.0908C4.66699 6.77711 7.35328 4.09082 10.667 4.09082C13.9807 4.09082 16.667 6.77711 16.667 10.0908C16.667 13.4045 13.9807 16.0908 10.667 16.0908C7.35328 16.0908 4.66699 13.4045 4.66699 10.0908Z",
    fill: "#005FF9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchSm);
export default __webpack_public_path__ + "static/media/search-sm.1b7c29f578f8859c9b503dcdf8eacf49.svg";
export { ForwardRef as ReactComponent };